import { getConfig } from '@metorial/frontend-config';
import { SetupLayout } from '@metorial/layout';
import { Button, Callout, Spacer } from '@metorial/ui';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import bg from '../../../assets/bg.webp';

// Error codes set by the core API's Google callback (apis/auth).
let errorMessages: Record<string, string> = {
  not_configured: "Google sign-in isn't set up on this server yet.",
  cancelled: 'Google sign-in was cancelled.',
  expired: 'Your sign-in attempt expired. Please try again.',
  wrong_domain: 'Sign in with your Blackboard Studio Google Workspace account.',
  unverified_email: "Your Google account's email address isn't verified.",
  member_removed: 'An admin removed your access. Ask them to invite you again.',
  user_deactivated: 'Your account has been deactivated.',
  failed: 'Something went wrong while signing you in. Please try again.'
};

export let AuthLoginPage = () => {
  let [search] = useSearchParams();
  let redirect = search.get('redirect_uri');
  let error = search.get('error');
  // Signed in, but not a member of the organization (core API authentication).
  let denied = error == 'access_denied';

  let [redirecting, setRedirecting] = useState(false);

  let signIn = () => {
    let url = new URL('/_/auth/google', getConfig().apiUrl);
    if (redirect) url.searchParams.set('redirect_uri', redirect);

    setRedirecting(true);
    location.assign(url.toString());
  };

  return (
    <SetupLayout
      main={
        denied
          ? { title: 'Access denied' }
          : {
              title: 'Sign in',
              description: 'Use your Blackboard Studio Google Workspace account.'
            }
      }
      backgroundUrl={bg}
    >
      <Button fullWidth onClick={signIn} loading={redirecting}>
        {denied ? 'Use another account' : 'Continue with Google'}
      </Button>

      {error && !denied && (
        <>
          <Spacer size={15} />
          <Callout color="red">{errorMessages[error] ?? errorMessages.failed}</Callout>
        </>
      )}
    </SetupLayout>
  );
};
